import watchGetDetails from './getDetails';
import watchGetChargeLines from './getChargeLines';

const watchInvoiceDetails = [watchGetDetails, watchGetChargeLines];

export default watchInvoiceDetails;
